import React, { useState } from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { ResponseError } from 'superagent';
import { Default as Alert } from '@gjensidige/core-alerts';
import { AlertTypeProps } from '@gjensidige/core-alerts/lib/types';
import utils from '@gjensidige/core-utilities-css';
import {
  ActionButton,
  PrimaryButton,
  SecondaryButton
} from '@gjensidige/nci-core-buttons';
import { Input } from '@gjensidige/nci-core-forms/lib/input';
import { KeyboardArrowLeft } from '@gjensidige/nci-core-icons';
import { Text, Title } from '@gjensidige/nci-core-typography';

import styles from '../assets/styles/shared.module.scss';
import { login } from '../service/api';

export const LoginGuest: React.FunctionComponent = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [usernameInvalid, setUsernameInvalid] = useState(false);
  const [passwordInvalid, setPasswordInvalid] = useState(false);
  const [message, setMessage] = useState({
    type: '' as AlertTypeProps['alertType'],
    text: ''
  });
  const [loading, setLoading] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const referer = urlParams.get('referer');
  const paramString = referer ? `?referer=${referer}` : '';
  const history = useHistory();

  const handleClick = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);

    const body = { user: username, password: password };
    const response = await login(body);

    if (response.status === 200) {
      window.location.href = `${window.location.origin}${
        referer ? referer : '/'
      }`;
      setLoading(false);
    } else {
      const responseError = response as ResponseError;
      setLoading(false);
      setMessage({
        type: 'error',
        text: responseError.response?.body?.errors[0]
      });
    }
  };

  const checkInputs = () => {
    username === '' ? setUsernameInvalid(true) : setUsernameInvalid(false);
    password === '' ? setPasswordInvalid(true) : setPasswordInvalid(false);
  };

  return (
    <div className={classNames(styles.overrides, utils['ml-md-4'])}>
      {message.type && (
        <Alert
          alertType={message.type as AlertTypeProps['alertType']}
          className={utils['mb-2']}
        >
          <Text size="p">{message.text}</Text>
        </Alert>
      )}
      <Title size="h3" tag="h1">
        Log in and get started
      </Title>
      <form
        className={classNames(utils['mt-2'], styles.formMargin)}
        action="#"
        onSubmit={(event) => handleClick(event)}
      >
        <Input
          id="username"
          name="username"
          labelText="Enter username/email"
          errorText="Username is required"
          placeholder="E-mail"
          autoComplete="username"
          invalid={usernameInvalid}
          value={username}
          onChange={(event: {
            currentTarget: { value: React.SetStateAction<string> };
          }) => setUsername(event.currentTarget.value)}
          required={true}
          className={styles.inputWidth}
        />
        <Input
          type="password"
          id="password"
          name="password"
          placeholder="Password"
          labelText="Enter password"
          errorText="Password is required"
          autoComplete="current-password"
          invalid={passwordInvalid}
          value={password}
          onChange={(event: {
            currentTarget: { value: React.SetStateAction<string> };
          }) => setPassword(event.currentTarget.value)}
          required={true}
          className={classNames(styles.inputWidth, utils['mt-1'])}
        />

        <div className={utils['mt-2']}>
          <PrimaryButton
            type="submit"
            loading={loading}
            onClick={() => checkInputs()}
            className={classNames(utils['mr-1'], utils['mb-1'])}
          >
            Log in
          </PrimaryButton>
          {
            /**
             * @todo Add register new user logic
             * @body Need to find out how to send passwords and tokens in a secure way
             */
            <SecondaryButton
              onClick={(event: React.SyntheticEvent<HTMLButtonElement>) => {
                event.preventDefault();
                history.push('/register-user');
              }}
            >
              Register new user
            </SecondaryButton>
          }
        </div>
        <ActionButton
          className={classNames(styles.secondaryButton, utils['mt-1'])}
          onClick={(event: React.SyntheticEvent<HTMLButtonElement>) => {
            event.preventDefault();
            history.push(`/${paramString}`);
          }}
          icon={<KeyboardArrowLeft />}
        >
          Go back
        </ActionButton>
      </form>
    </div>
  );
};
